import React from "react";
import { Link } from "react-router-dom";

function Row({ node, level, expanded, toggle, path }) {
  const hasChildren = (node.children?.length || 0) > 0;
  const isOpen = expanded.has(node.id);

  return (
    <>
      <tr>
        <td style={{width:36}}><input type="checkbox" /></td>
        <td>
          <div style={{ display:"flex", alignItems:"center", gap:8 }}>
            <div style={{ paddingLeft: level * 20 }}>
              {hasChildren ? (
                <button
                  className="oc-ico-btn"
                  title={isOpen ? "Collapse" : "Expand"}
                  onClick={() => toggle(node.id)}
                  style={{ transform: isOpen ? "rotate(90deg)" : "none" }}
                >▶</button>
              ) : <span style={{ display:"inline-block", width:24 }}></span>}
            </div>
            <span className="oc-strong">{node.name}</span>
          </div>
          <div className="oc-bc small">{path.join(" › ")}</div>
        </td>
        <td className="oc-mono" style={{width:80}}>{node.sort_order ?? 0}</td>
        <td style={{width:120}}>
          {String(node.status) === "1" ? (
            <span className="oc-badge green">Enabled</span>
          ) : (
            <span className="oc-badge gray">Disabled</span>
          )}
        </td>
        <td style={{width:120}}>
          <div className="oc-row-actions">

            <Link to={`/catalog/categories/${node.id}`}>
              <button className="oc-ico-btn" title="Edit">✏️</button>
            </Link>
          </div>
        </td>
      </tr>

      {hasChildren && isOpen && node.children.map((child) => (
        <Row
          key={child.id}
          node={child}
          level={level + 1}
          expanded={expanded}
          toggle={toggle}
          path={[...path, child.name]}
        />
      ))}
    </>
  );
}

export default function CategoriesTable({ tree }) {
  const [expanded, setExpanded] = React.useState(new Set());
  const toggle = (id) => {
    setExpanded((s) => {
      const n = new Set(s);
      if (n.has(id)) n.delete(id); else n.add(id);
      return n;
    });
  };

  return (
    <div className="oc-table-wrap">
      <table className="oc-table">
        <thead>
          <tr>
            <th style={{width:36}}><input type="checkbox" /></th>
            <th>Category Name</th>
            <th>Sort Order</th>
            <th>Status</th>
            <th style={{width:120}}>Action</th>
          </tr>
        </thead>
        <tbody>
          {tree.length === 0 && (
            <tr><td colSpan={5} style={{textAlign:"center",padding:24}}>No categories found</td></tr>
          )}
          {tree.map((root) => (
            <Row
              key={root.id}
              node={root}
              level={0}
              expanded={expanded}
              toggle={toggle}
              path={[root.name]}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}

